export function throttle(func, timeout) {
  
  let timer = null

  return function wrapper(...args) {
    if (timer) return;

    timer = setTimeout(() => {
      func(...args);

      timer = null;
    }, timeout);
  }
}


// function throttle(func, timeout) {
// // - func, функция, которую надо вызывать;
// // - timeout, интервал в мс, с которым следует пропускать вызовы.

//   // Таймер будет определять, надо ли нам пропускать текущий вызов.
//   let timer = null

//   // Как результат возвращаем другую функцию.
//   // Это нужно, чтобы мы могли не менять другие части кода

//   return function wrapper(...args) {
//     // Если таймер есть, то функция уже была вызвана,
//     // и значит новый вызов следует пропустить.
//     if (timer) return

//     // Если таймера нет, значит мы можем вызвать функцию:
//     timer = setTimeout(() => {
      
//       func(...args)// Аргументы передаём неизменными в функцию-аргумент:

//       // По окончании сбрасываем таймер:
//       timer = null
//     }, timeout)
//   }
// }